import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';

export const appInitializerFactory = (translate: TranslateService, injector: Injector) => () => new Promise<any>((resolve: any) => {
  const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
  locationInitialized.then(async () => {
    translate.addLangs(['nl', 'de', 'en']);
    for (const l of translate.langs) {
      await translate.use(l).toPromise();
    }
    await translate.use(translate.defaultLang).toPromise();
    resolve(null);
  });
});
